import { createRootRoute, Outlet, ScrollRestoration } from '@tanstack/react-router';
import { Layout } from '@/components/Layout';
import { ProductDetailModal } from '@/components/ProductDetailModal';
import { CartDrawer } from '@/components/CartDrawer';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Layout>
        <Outlet />
      </Layout>
      <ProductDetailModal />
      <CartDrawer />
      <ScrollRestoration />
    </>
  );
}
